import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiDialog from "components/Custom/UiDialog";

import { COMMON_JS } from "common/scripts";
import { DEFAULTS, NOTIFY } from "common/config";
import { DateFunctions } from "common/datefunctions";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/lables";

import { MASTER_APIs } from "apihandlers/master";
import { USER_APIs } from "apihandlers/user";

const AssetRequest = (props: any) => {
  const { setDashMenu } = props;

  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [gridLoading, setGridLoading] = useState(true);

  const [isSubmit, setIsSubmit] = useState(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [mandatoryDate, setMandatoryDate] = useState<any[]>([]);

  const [users, setUsers] = useState([]);
  const [asset, setAsset] = useState([]);

  const usersRef: any = useRef(null);
  const assetRef: any = useRef(null);

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "assetName",
      name: LABELS.ASSET,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "requestedByName",
      name: LABELS.REQUESTED_BY,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "qty",
      name: LABELS.QUANTITY,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "number",
      searchable: true,
    },
    {
      key: "remarks",
      name: LABELS.REMARKS,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },

    {
      key: "activeStatus",
      name: LABELS.ACTIVE,
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      searchable: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    USER_APIs.getUsers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setUsers(list);
        getAsset();
        // getRows();
      }
    });
  };
  const getAsset = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    MASTER_APIs.getAsset(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.assetName,
          };
        });
        setAsset(list);
        // getRows();
      }
    });
  };
  // const getRows = () => {
  //   const args = {
  //     pageNo: 1,
  //     pageLength: DEFAULTS.PAGE_LENGTH,
  //   };
  //   MASTER_APIs.getVehicleChecks(args).then((res: any) => {
  //     const response: any = res.response;
  //     const { status } = res;
  //     if (status === 200) {
  //       let list = response.records;
  //       for (let i = 0; i < list.length; i++) {
  //         list[i]["slNo"] = i + 1;
  //         if (list[i]["activeStatus"]) {
  //           list[i]["activeStatus"] = "Yes";
  //         } else {
  //           list[i]["activeStatus"] = "No";
  //         }
  //       }
  //       setRows(list);
  //       setLoading(false);
  //     }
  //   });
  // };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const reloadGrid = () => {
    setRows(null);
    loadGrid();
  };

  const loadGrid = () => {
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    let errors = [];
    if (fromDt === "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryDate(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    const args = {
      fromDt,
      toDt,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    setLoading(true);
    setGridLoading(false);

    MASTER_APIs.getAssetRequest(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
          list[i]["qty"] = Number(list[i].qty);
        }
        setRows(list);
        setLoading(false);
      }
    });
  };
  const manageRecord = () => {
    const assetId = assetRef.current.selectedValue.id;
    const requestedBy = usersRef.current.selectedValue.id;

    const qty = (
      document.getElementById("qty") as HTMLInputElement
    ).value.trim();
    const remarks = (
      document.getElementById("remarks") as HTMLInputElement
    ).value.trim();
    let ele = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = ele ? ele.value : "";

    // Validations;
    let errors = [];
    if (!assetId) {
      errors.push({
        id: "assetId",
        msg:
          "<span class='bold'>" +
          LABELS.ASSET +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (remarks === "") {
      errors.push({
        id: "remarks",
        msg:
          "<span class='bold'>" +
          LABELS.REMARKS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!requestedBy) {
      errors.push({
        id: "requestedBy",
        msg:
          "<span class='bold'>" +
          LABELS.REQUESTED_BY +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      assetId,
      requestedBy,
      qty: Number(qty),
      remarks,
      activeStatus,
    };
    console.log("args", args);
    setIsSubmit(true);
    MASTER_APIs.manageAssetRequest(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  console.log("Page: Country:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {LABELS.TRANSACTION}{" "}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.ASSET_REQUEST}</li>
        </ul>
        <h4>{TITLES.ASSET_REQUEST}</h4>
        <p>{SUB_TITLES.ASSET_REQUEST}</p>
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <div
          className="formGroup"
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 0,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 14,
                marginTop: 6,
                marginRight: 8,
              }}
            >
              {LABELS.FROM_DATE}
            </label>
            <TxtRow
              type={"date"}
              id="fromDt"
              defaultValue={DateFunctions.getDate(
                "today",
                "from",
                "YYYY-MM-DD"
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 14,
                marginTop: 6,
                marginRight: 8,
              }}
            >
              {LABELS.TO_DATE}
            </label>
            <TxtRow
              type={"date"}
              id="toDt"
              defaultValue={DateFunctions.getDate(
                "thismonth",
                "to",
                "YYYY-MM-DD"
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              padding: 10,
              marginTop: "0.3rem",
            }}
          >
            <Btn
              text={LABELS.LOAD}
              onClick={loadGrid}
              bgColor={COLORS.SAVE_GREEN}
            />
          </div>
        </div>
      </div>
      {mandatoryDate.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryDate.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className="grid excelGridWrapper">
        {!gridLoading &&
          (rows ? (
            <ExcelGrid
              id={"assetRequest"}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={LABELS.ASSET_REQUEST}
              onReload={reloadGrid}
              onAdd={onAdd}
            />
          ) : (
            <div className="flexRowCenter">
              <Loader />
            </div>
          ))}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + TITLES.ASSET_REQUEST + ": " + selectedRow.assetName
              : "Add " + TITLES.ASSET_REQUEST
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
            setMandatoryDate([]);
          }}
        >
          <div className="flexColumn">
            <div className="formGroup required ">
              <label>{LABELS.ASSET}</label>
              {<span className="red">{" *"}</span>}
              <AutoComplete
                list={asset}
                childRef={assetRef}
                defaultValue={
                  selectedRow.assetId
                    ? {
                        id: selectedRow.assetId,
                        label: selectedRow.assetName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>

            <div className="formGroup required ">
              <label>{LABELS.REQUESTED_BY}</label>
              {<span className="red">{" *"}</span>}
              <AutoComplete
                list={users}
                childRef={usersRef}
                defaultValue={
                  selectedRow.requestedBy
                    ? {
                        id: selectedRow.requestedBy,
                        label: selectedRow.requestedByName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup  ">
              <TxtRow
                id={"qty"}
                label={LABELS.QUANTITY}
                defaultValue={selectedRow.qty ? Number(selectedRow.qty) : ""}
                type={"number"}
                disabled={isSubmit}
              />
            </div>

            <div className="formGroup  ">
              <TxtRow
                id={"remarks"}
                label={LABELS.REMARK}
                required={true}
                defaultValue={selectedRow.remarks ? selectedRow.remarks : ""}
                type={"text"}
                disabled={isSubmit}
              />
            </div>

            <div className="formGroup required">
              <label>
                {LABELS.ACTIVE_STATUS}
                <span className="red">{" *"}</span>
              </label>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.ACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "Yes"
                      : true,
                    disabled: isSubmit,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.INACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "No"
                      : false,
                    disabled: isSubmit,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                required={true}
                disabled={isSubmit}
              />
            </div>
            {/* mandatoryResults */}

            {mandatoryResults.length > 0 && (
              <div className="mandatoryBox">
                <ul>
                  {mandatoryResults.map((m) => {
                    return (
                      <li>
                        <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            <div className="formGroup submitBtnWrapper">
              <div className="flexbtnjustify">
                <Btn
                  text={LABELS.CANCEL}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={() => {
                    setManageDialog(false);
                    setMandatoryResults([]);
                    setMandatoryDate([]);
                  }}
                  loading={isSubmit}
                />
                <Btn
                  text={LABELS.SAVE}
                  onClick={manageRecord}
                  loading={isSubmit}
                  bgColor={COLORS.SAVE_GREEN}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};
export default withSnackbar(AssetRequest);
